export const CONTENT_EVENTS = {
  collectionOpened: 'content_collection_opened',
  collectionPressed: 'content_collection_pressed',
  featuredCollectionPressed: 'content_featured_collection_pressed',
  challengeOpened: 'content_challenge_opened',
  episodePressed: 'content_episode_pressed',
  searchOpened: 'content_search_opened',
  searchExecuted: 'content_search_executed',
  searchResultPressed: 'content_search_result_pressed',
  itemShared: 'content_item_shared',
  shareCancelled: 'content_share_cancelled',
  movieWatched: 'content_movie_watched',
  movieUnwatched: 'content_movie_unwatched',
  movieRated: 'content_movie_rated',
  movieRewatched: 'content_movie_rewatched',
  movieWatchlistAdded: 'content_movie_watchlist_added',
  movieWatchlistRemoved: 'content_movie_watchlist_removed',
  bookmarkAdded: 'content_bookmark_added',
  bookmarkRemoved: 'content_bookmark_removed',
  bookmarksOpened: 'content_bookmarks_opened',
  bookmarksPracticeStarted: 'content_bookmarks_practice',
} as const;

export type ContentEventNameType = (typeof CONTENT_EVENTS)[keyof typeof CONTENT_EVENTS];
